import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
class Faqspage extends Component {
  render() {
    return (
      <div>
        <div aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <Link>
                <FontAwesomeIcon icon={faHome} /> &nbsp; HOME
              </Link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              FAQ's
            </li>
          </ol>
        </div>
        <section class="padding-default">
          <div class="row">
            <aside class="col-lg-4" id="sidebar">
              <div class="box_style_cat" id="faq_box">
                <ul id="cat_nav">
                  <li>
                    <a href="#Courses" class="active">
                      <i class="fa fa-angle-right"></i>Courses
                    </a>
                  </li>
                  <li>
                    <a href="#Payments">
                      <i class="fa fa-angle-right"></i>Payments
                    </a>
                  </li>
                  <li>
                    <a href="#GradingAccomplishments">
                      <i class="fa fa-angle-right"></i>Grading and
                      Accomplishments
                    </a>
                  </li>
                  <li>
                    <a href="#RecommendedBrowsersDevices">
                      <i class="fa fa-angle-right"></i>Recommended Browsers and
                      Devices
                    </a>
                  </li>
                  <li>
                    <a href="#AccountSettings">
                      <i class="fa fa-angle-right"></i>Account Settings
                    </a>
                  </li>
                  <li>
                    <a href="#Troubleshooting">
                      <i class="fa fa-angle-right"></i>Troubleshooting
                    </a>
                  </li>
                </ul>
              </div>
            </aside>

            <div class="col-lg-8" id="faq">
              <h4>
                <br />
                Courses
              </h4>
              <div
                role="tablist"
                class="add_bottom_45 accordion_2"
                id="Courses"
              >
                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        data-toggle="collapse"
                        href="#collapseOne_payment"
                        aria-expanded="true"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;What
                        does an edu plus now course include?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseOne_payment"
                    class="collapse show"
                    role="tabpanel"
                    data-parent="#Courses"
                  >
                    <div class="card-body">
                      <p>
                        The courses at edu plus now are created and managed by
                        the instructors. The lectures include slides, videos,
                        text and additional resources. In addition, instructors
                        can add quizzes, practice tests, and assignments to
                        augment the learning experience of students.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseTwo_payment"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;How do I
                        enroll in a course?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo_payment"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Courses"
                  >
                    <div class="card-body">
                      <p>
                        Open the course information page by clicking on the
                        course title from the edu plus now catalog.
                      </p>
                      <p>Click on the Enroll button.</p>
                      <p>Follow the instructions to enroll in the course.</p>
                    </div>
                  </div>
                </div>

                <div class="card"  id="Payments">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseThree_payment"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;How long
                        do I have to complete a course?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseThree_payment"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Courses"
                  >
                    <div class="card-body">
                      <p>
                        The deadlines for starting and completing the course and
                        the assignments will be provided once you sign up for
                        the course. Most of our courses are self-paced courses.
                        Once you’ve signed up for the course, you will have a
                        lifetime access to it.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseFour_payment"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;Is edu
                        plus now an accredited university?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseFour_payment"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Courses"
                  >
                    <div class="card-body">
                      <p>
                        edu plus now is not an accredited institution. We offer
                        industry-recognized technology courses taught by
                        professors and experts in their field. Every course is
                        awarded a digital certificate of completion that can be
                        saved and shared.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h4 class="">
                <b />
                Payments
              </h4>
              <div
                role="tablist"
                class="add_bottom_45 accordion_2"
               
              >
                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        data-toggle="collapse"
                        href="#collapseOne_tips"
                        aria-expanded="true"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;How do I
                        pay for a course?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseOne_tips"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Payments"
                  >
                    <div class="card-body">
                      <p>
                        After you find the course you wish to enroll in, click
                        “Buy Now” on the course landing page. You will be
                        directed to the Checkout page, which will feature the
                        various payment methods that are available to you.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseTwo_tips"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;What if
                        I don’t like a course I purchased?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo_tips"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Payments"
                  >
                    <div class="card-body">
                      <p>
                        In case you’re unhappy with the course content, you can
                        request a refund within 7 days of purchasing a course.
                        On the course dashboard, click on the Request Refund tab
                        to check the steps for requesting a refund.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card" id="GradingAccomplishments">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseThree_tips"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;What are
                        the reasons for denial of refund?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseThree_tips"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Payments"
                  >
                    <div class="card-body">
                      <p>
                        The edu plus now refund policy is in place to protect
                        students. However, our instructors also need to be
                        protected from fraud and provide a reasonable payment
                        schedule. Payments are sent to instructors after 7 days,
                        so we will not process refund requests received after
                        the refund window. The refund request will be denied if
                        the student has downloaded the course content before the
                        request for refund is sent. If a student has purchased
                        and refunded multiple courses, he/she may be subject to
                        suspension for abuse of the refund policy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h4 class="">
                <br />
                Grading and Accomplishments
              </h4>
              <div
                role="tablist"
                class="add_bottom_45 accordion_2"
                
              >
                <div class="card"  id="RecommendedBrowsersDevices">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        data-toggle="collapse"
                        href="#collapseOne_reccomendations"
                        aria-expanded="true"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;How do I
                        access my assignment grades?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseOne_reccomendations"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#GradingAccomplishments"
                  >
                    <div class="card-body">
                      <p>
                        Open the course you are enrolled in and click on the
                        Grades in the left-hand menu. You’ll be able to see each
                        graded assignment in the course, how many assignments
                        you’ve completed, personalized deadlines for assignments
                        and how the assignment counts towards the final course
                        grade. In case you’re unable to access your assignment
                        grades, send a message to the instructor.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <h4>
                <br />
                Recommended Browsers and Devices
              </h4>
              <div
                role="tablist"
                class="add_bottom_45 accordion_2"
               
              >
                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        data-toggle="collapse"
                        href="#collapseOne_terms"
                        aria-expanded="true"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;What are
                        the recommended devices?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseOne_terms"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#RecommendedBrowsersDevices"
                  >
                    <div class="card-body">
                      <p>
                        edu plus now courses are available on multiple devices
                        including a desktop/laptop, Android app, and iOS app. To
                        access the course, you will need a broadband connection
                        with a minimum speed of 800kbps or 5 Mbit. A flash
                        player is not required.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseTwo_terms"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;Which
                        browsers are supported by the edu plu snow platform?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo_terms"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#RecommendedBrowsersDevices"
                  >
                    <div class="card-body">
                      <p>
                        edu plus now supports the most recent versions of the
                        following browsers on computers: Google Chrome
                        (recommended) Firefox Safari Internet Explorer 11
                        Microsoft Edge If you're using an older browser,
                        updating your browser can help solve problems.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseThree_terms"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;How do I
                        log into my edu plus now account?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseThree_terms"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#RecommendedBrowsersDevices"
                  >
                    <div class="card-body">
                      <p>
                        To log into the edu plus now account, use your
                        registered email address and password. If you can’t
                        login to your account, try resetting your account
                        password.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseFour_terms"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;My email
                        address is not working. What do I do?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseFour_terms"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#RecommendedBrowsersDevices"
                  >
                    <div class="card-body">
                      <p>
                        If you see a message that says "We are unable to find an
                        account associated with this email address" when you try
                        to log in or change your password, the problem could be:
                        You may be using an email address that is different from
                        your edu plus now registered email id You may have
                        mis-typed your email address when you made your edu plus
                        now account. Try entering common typos or variations on
                        your email address If you’re still unable to use your
                        email address, contact customer support
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseFive_terms"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;What do
                        I do if the course I enrolled for is missing in my
                        account?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseFive_terms"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#RecommendedBrowsersDevices"
                  >
                    <div class="card-body">
                      <p>
                        Check the Enrollments tab after you enroll for a course.
                        If you’re unable to view the course, please ensure that
                        you are logged into the same email account that is
                        registered to your edu plus now account, and that you
                        received an enrollment confirmation email for the
                        course. Check your Spam mail folder if you don’t see the
                        enrollment confirmation email in your inbox.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card" id="AccountSettings">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseSix_terms"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;How do I
                        verify my email?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseSix_terms"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#RecommendedBrowsersDevices"
                  >
                    <div class="card-body">
                      <p>
                        Search your email inbox for an email called “Action
                        Required: Please confirm your email” and click on the
                        link provided inside. If you have not received this
                        email, try sending the confirmation email again or check
                        your “Spam” folder.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h4 class="">
                <br />
                Account Settings
              </h4>
              <div
                role="tablist"
                class="add_bottom_45 accordion_2"
                
              >
                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        data-toggle="collapse"
                        href="#collapseOne_booking"
                        aria-expanded="true"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;How do I
                        make changes to the edu plus now account settings?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseOne_booking"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#AccountSettings"
                  >
                    <div class="card-body">
                      <p>
                        On the accounts setting page, you can change your name,
                        email address, time zone and password for edu plus now
                        account.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseTwo_booking"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;How do I
                        change the email settings?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo_booking"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#AccountSettings"
                  >
                    <div class="card-body">
                      <p>
                        To change your email settings from edu plus now, open
                        your accounts setting page. On the left side of the
                        screen, click Email Preferences. Use the checkboxes to
                        choose what kinds of emails you'd like to get from edu
                        plus now and click save.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card"  id="Troubleshooting">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseThree_booking"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;Can I
                        login using social media?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseThree_booking"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#AccountSettings"
                  >
                    <div class="card-body">
                      <p>
                        edu plus now allows social media logins through Google+,
                        Facebook and LinkedIn.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <h4 class="">
                <br />
                Troubleshooting
              </h4>
              <div
                role="tablist"
                class="add_bottom_45 accordion_2"
               
              >
                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        data-toggle="collapse"
                        href="#collapseOne_Troubleshooting"
                        aria-expanded="true"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;What do
                        I do if I am unable to stream the courses?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseOne_Troubleshooting"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Troubleshooting"
                  >
                    <div class="card-body">
                      <p>
                        If your video keeps buffering or loading, try the
                        following troubleshooting tips before contacting
                        Support. Refresh your browser Quit your browser and
                        re-open it Clear your browser's cookies and cache. Be
                        sure to restart your browser before trying again Try a
                        different browser, like Google Chrome Take a note of
                        your browser extensions/plugins/firewall programs. Is
                        there anything that could be interfering with the
                        streaming of the videos? We recommend testing with an
                        incognito window to troubleshoot Check your browser
                        version and update it if needed. Log out of edu plus now
                        and log back in Restart your computer and network
                        devices (modems/switches/routers) Try a different device
                        or computer if possible Turn off hardware acceleration
                        Try lowering the video quality of the lecture Test your
                        internet connection speed
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseTwo_Troubleshooting"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;I am
                        unable to hear the videos. What do I do?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo_Troubleshooting"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Troubleshooting"
                  >
                    <div class="card-body">
                      <p>
                        Refresh your browser Quit your browser and re-open it
                        Log out of edu plus now and log back in Clear your
                        browser's cookies and cache. Be sure to restart your
                        browser before trying again Take a note of your browser
                        extensions/plugins/firewall programs and adblockers. Is
                        there anything that could be interfering with the audio?
                        We recommend testing with an incognito window to
                        troubleshoot Check the sound settings on your device
                        Check to see if other lectures in the programme are
                        producing sound
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h5 class="mb-0">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseThree_Troubleshooting"
                        aria-expanded="false"
                      >
                        <i class="indicator fa fa-plus"></i>&nbsp;&nbsp;What do
                        I do if I am unable to purchase a course?
                      </a>
                    </h5>
                  </div>
                  <div
                    id="collapseThree_Troubleshooting"
                    class="collapse"
                    role="tabpanel"
                    data-parent="#Troubleshooting"
                  >
                    <div class="card-body">
                      <p>
                        Ensure your Debit and Credit card is authorized for
                        payments Ensure you are entering the first and last name
                        of the card account holder, exactly as it appears on the
                        card in the Name on Card field Multiple IP addresses can
                        trigger card authorization problems. Refrain from using
                        a virtual private network (VPN) while making a purchase
                        on edu plus now, which may cause the transaction to fail
                        Check usage limitations. The card may automatically
                        block payment attempts after a certain threshold has
                        been reached If the information you’ve entered is
                        correct, try clearing the cache and try again
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <br /><br />
      </div>
    );
  }
}

export default Faqspage;
